import { useWorkspaceFeatures } from '@platform/hooks/useWorkspaceFeatures'
import { ROUTES } from '@platform/router/paths'
import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/$workspaceId/files/$docId/'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { workspaceId, docId } = Route.useParams()
  const { hasAttributesConfig, hasGraphConfig } = useWorkspaceFeatures()

  const to = hasAttributesConfig
    ? ROUTES.filesDocumentAttributes
    : hasGraphConfig
      ? ROUTES.filesDocumentGraphs
      : ROUTES.filesDocumentInformation

  return <Navigate to={to} params={{ workspaceId, docId }} replace />
}
